import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BottomTabBar from '../../components/feature/BottomTabBar';
import CourierStatusCard from '../../components/home/CourierStatusCard';
import ActiveJobCard from '../../components/home/ActiveJobCard';
import EmptyJobCard from '../../components/home/EmptyJobCard';
import QuickActionGrid from '../../components/home/QuickActionGrid';
import TodaySummaryCard from '../../components/home/TodaySummaryCard';
import InfoBanner from '../../components/home/InfoBanner';

export default function Home() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isOnline, setIsOnline] = useState(true);
  const [greeting, setGreeting] = useState('');
  
  // Mock data - aktif teslimat var mı?
  const hasActiveDelivery = true;
  const activeJob = {
    orderId: 'DOM2847',
    pickupAddress: 'Domino\'s Stockholm City, Drottninggatan 45',
    dropoffAddress: 'Kungsgatan 12, 3rd floor',
    eta: '8 min',
  };
  
  // Günün özeti
  const todaySummary = {
    deliveries: 6,
    earnings: 420,
    avgTime: 18,
    dailyGoal: 8,
  };
  
  // Selamlama mesajını ayarla
  useEffect(() => {
    const hour = new Date().getHours();
    if (hour < 12) {
      setGreeting(t('goodMorning'));
    } else if (hour < 18) {
      setGreeting(t('goodAfternoon'));
    } else {
      setGreeting(t('goodEvening'));
    }
  }, [t]);
  
  // Hızlı aksiyonlar
  const quickActions = [
    {
      id: 'jobs',
      icon: 'ri-compass-3-line',
      label: t('findJobs'),
      onClick: () => navigate('/jobs'),
    },
    {
      id: 'map',
      icon: 'ri-map-2-line',
      label: t('openMap'),
      onClick: () => {
        // Map functionality
      },
    },
    {
      id: 'support',
      icon: 'ri-customer-service-2-line',
      label: t('support'),
      badge: 1,
      onClick: () => {
        // Support functionality
      },
    },
    {
      id: 'schedule',
      icon: 'ri-calendar-line',
      label: t('mySchedule'),
      onClick: () => navigate('/schedule'),
    },
  ];
  
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header / Greeting */}
      <div className="bg-white px-4 pt-12 pb-6 shadow-sm">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <h1 className="text-2xl font-bold text-gray-900 mb-1">
              {greeting}, Burhan 👋
            </h1>
            <p className="text-sm text-gray-600">
              {isOnline ? t('youAreOnline') : t('youAreOffline')}
            </p>
          </div>
          
          <div className="flex items-center gap-3">
            <div className={`w-2.5 h-2.5 rounded-full ${isOnline ? 'bg-green-500' : 'bg-gray-400'} ${isOnline ? 'animate-pulse' : ''}`}></div>
            
            <button className="relative w-10 h-10 flex items-center justify-center">
              <i className="ri-notification-3-line text-xl text-gray-700"></i>
              <div className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></div>
            </button>
          </div>
        </div>
      </div>
      
      {/* Content */}
      <div className="px-4 py-5 space-y-4">
        {/* Courier Status Card */}
        <CourierStatusCard
          isOnline={isOnline}
          onToggle={() => setIsOnline(!isOnline)}
          vehicleType="bike"
        />
        
        {/* Active Job or Empty State */}
        {hasActiveDelivery && isOnline ? (
          <ActiveJobCard
            orderId={activeJob.orderId}
            pickupAddress={activeJob.pickupAddress}
            dropoffAddress={activeJob.dropoffAddress}
            eta={activeJob.eta}
            onClick={() => navigate(`/job/${activeJob.orderId}`)}
          />
        ) : (
          <EmptyJobCard onViewJobs={() => navigate('/jobs')} />
        )}
        
        {/* Info Banner */}
        <InfoBanner message={t('highDemandExpected')} />
        
        {/* Quick Actions */}
        <QuickActionGrid actions={quickActions} />
        
        {/* Today's Summary */}
        <TodaySummaryCard
          deliveries={todaySummary.deliveries}
          earnings={todaySummary.earnings}
          avgTime={todaySummary.avgTime}
          dailyGoal={todaySummary.dailyGoal}
        />
      </div>
      
      <BottomTabBar />
    </div>
  );
}
